module.exports = __webpack_public_path__ + "lr.7f661fb0.svg";